/**
 * Centralized tracking configuration.
 *
 * Single source of truth for event names and CSS selectors used by
 * GTM, ProfitMetrics Hybrid, Meta Pixel and Leadinfo.
 *
 * Edit values here — do NOT hardcode event names or selectors elsewhere.
 * See also: mem://marketing/profitmetrics-selector-policy.md
 */

export const TRACKING_EVENTS = {
  /** GTM Custom Event fired right after consent is saved (no page-refresh trigger). */
  COOKIE_CONSENT_UPDATE: "cookie_consent_update",
  /** Visitor identity push (login/register/forgot-password email captured). */
  PM_IDENTITY: "pm_identity",
} as const;

export const TRACKING_SELECTORS = {
  /** Suffix-match selector for ALL legitimate visitor-identity email inputs.
   *  Use this string verbatim in the ProfitMetrics dashboard. */
  EMAIL_INPUTS: '[data-track$="-email"]',
} as const;

export const TRACKING_WINDOW_EVENTS = {
  /** Internal browser CustomEvent — TrackingScripts.tsx listens for instant script injection. */
  COOKIE_CONSENT_UPDATED: "cookie-consent-updated",
  /** Footer link dispatches this to re-open the cookie banner. */
  COOKIE_BANNER_REOPEN: "cookie-banner-reopen",
} as const;

/** Days after which stored consent expires and the banner is shown again (AVG/ePrivacy: max 12 mnd). */
export const CONSENT_TTL_DAYS = 365;
/** Bump when categories or wording materially change to force re-consent. */
export const CONSENT_VERSION = "1";

export const TRACKING_STORAGE_KEYS = {
  CONSENT: "cookie-consent",
  PREFERENCES: "cookie-preferences",
} as const;
